"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _dexie = _interopRequireDefault(require("dexie"));
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = props => {
  const {
    src,
    v = 1,
    maxSize = 1024 * 1000,
    onClick
  } = props;
  const [img, setImg] = (0, _react.useState)('');
  const [imgError, setImgError] = (0, _react.useState)();
  const idb = new _dexie.default('img-store');
  idb.version(1).stores({
    images: 'src,blob,v'
  });
  const propsImg = () => Object.entries(props).map(entries => {
    const [attr, value] = entries;
    if (!/^(on)|(maxSize|v|src)$/.test(attr)) {
      return "".concat(attr === 'className' ? 'class' : attr, "=\"").concat(value, "\" ");
    }
    return '';
  }).join('').trim();
  if (!src) {
    console.error('Component <Img />: attribute src undefined');
    return false;
  }
  const blobToBitmap = blob => setImg("<img src=\"".concat(URL.createObjectURL(blob), "\" ").concat(propsImg(), " />"));
  const blobToSvg = e => e.text().then(f => {
    const data = f.replace(/(<\?(\n|.)+?\?>|<!--(\n|.)+?-->|\s(version|x|y|style|(xml:|xmlns:).+?)=".+?")/g, '').replace(/(\s|\n\s)+/g, ' ').replace(/>\s+</g, '><').replace(/\s+<\//g, '</').replace(/<style(\n|.)+?<\/style>/g, '').replace(/<svg/, "<svg ".concat(propsImg()));
    setImg(data);
  });
  const imgDetected = blob => blob.type === 'image/svg+xml' ? blobToSvg(blob) : blobToBitmap(blob);
  const imgFetch = _ref => {
    let {
      table,
      action
    } = _ref;
    const url = src.replace(/((\?|#).+|(\?|#|\/)$)/g, '');
    _axios.default.get(url, {
      responseType: 'blob'
    }).then(e => {
      const blob = e.data;
      const {
        type,
        size
      } = blob;
      if (!/^image/.test(type)) {
        return setImgError("file \"".concat(url, "\" isn't image/*"));
      }
      if (size > maxSize) {
        return setImgError("file size is more then ".concat(maxSize / 1024, "kb"));
      }
      imgDetected(blob);
      setTimeout(() => {
        const tableActions = {
          add: () => table.add({
            src: url,
            v,
            blob
          }),
          update: () => table.update(url, {
            v,
            blob
          })
        };
        if (tableActions[action]) {
          tableActions[action]();
        }
      }, 10);
      return blob;
    }).catch(e => setImgError("file \"".concat(url, "\" error: \"").concat(e.message, "\"")));
  };
  const imgGet = _ref2 => {
    let {
      table,
      data
    } = _ref2;
    return data.v !== v ? imgFetch({
      table,
      action: 'update'
    }) : imgDetected(data.blob);
  };
  const imgRender = () => {
    const {
      images
    } = idb;
    idb.transaction('rw', images, () => {
      images.get({
        src
      }).then(data => !data ? imgFetch({
        table: images,
        action: 'add'
      }) : imgGet({
        table: images,
        data
      })).catch(data => console.error({
        data
      }));
    });
  };
  (0, _react.useEffect)(() => imgRender(), [src]);
  return _react.default.createElement("span", {
    "data-src": src,
    "data-error": imgError,
    "data-version": v === 1 ? undefined : v,
    dangerouslySetInnerHTML: {
      __html: img
    },
    onClick: onClick
  });
};
exports.default = _default;